module.exports = __webpack_public_path__ + "img/answer3_incorrect.efaa191b.png";